module.exports = __webpack_public_path__ + "media/tips/02_grand_vetements-0d85ee87.jpg";